import axios from '@/plugins/axios.js';
import moment from '@/plugins/vue-moment.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default {
    state: {
        isLoading: false,

        auth: {
            client_id: null,
            client_name: null,
            user_id: null,
            access_token: null,
            expires_at: null,
            refresh_token: null,
            scope: null,
            token_type: null,
            created_at: null,
            updated_at: null,
        },

        user: null,
    },

    getters: {
        isAuthenticated: state => !!state.auth.access_token && moment.utc(state.auth.expires_at).diff(moment.utc()) > 0,
    },

    actions: {
        async fetch({ commit }) {
            try {
                commit('TOGGLE_LOADING');

                const queryBuilder = new QueryBuilder('third-party-access').filter('client_name', 'Zoom');

                const { data } = await axios.get(queryBuilder.toUrl());

                if (data.data) {
                    commit('AUTHORIZED', data.data);
                }
            } finally {
                commit('TOGGLE_LOADING');
            }
        },

        async store({ commit }, payload) {
            commit('AUTHORIZED', payload);

            return axios.post('/api/third-party-access', {
                client: 'Zoom',
                ...payload,
            });
        },
    },

    mutations: {
        AUTHORIZED(state, payload) {
            Object.keys(state.auth).forEach(key => (state.auth[key] = payload[key]));
        },

        USER(state, user) {
            state.user = user;
        },

        TOGGLE_LOADING(state) {
            state.isLoading = !state.isLoading;
        },
    },
};
